module.exports = __webpack_public_path__ + "static/media/balsamiq.13f3242d.svg";